import { http } from '../../core/api/client'
import type { Paginated } from '../../core/api/types'
import type { SelectOption, SelectOptionsLoader } from './SearchableSelect'

/** Adapter REST paginado padrão, preservando filtros de tenant/contexto do endpoint. */
export function createRemoteOptionsLoader<T>(
  path: string,
  toOption: (item: T) => SelectOption,
  params: Record<string, string | number | boolean | undefined> = {},
): SelectOptionsLoader {
  return async ({ query, page, pageSize, signal }) => {
    const result = await http.get<Paginated<T>>(path, {
      params: { ...params, q: query || undefined, page, per_page: pageSize },
      signal,
    })
    return {
      items: result.items.map(toOption),
      page: result.page,
      pages: result.pages,
      total: result.total,
    }
  }
}
